import script from "./ListCampaigns.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListCampaigns.vue?vue&type=script&lang=ts&setup=true"

import "./ListCampaigns.vue?vue&type=style&index=0&id=1422b0e2&lang=css"

export default script